import {t} from 'i18next';
class TranslationUtils {
    static getStepInfo(name) {
        const steps = t(`steps.${name}`, {returnObjects: true});
        return steps;
    }
}
export default TranslationUtils;